// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"edc326a1","150":"480899a3","210":"3d07d8d1","263":"3502af22","488":"bab1e1b1","532":"af103948","871":"43291664","887":"8695f78c"}[chunkId] + ".chunk.js";
};